import type React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../lib/stores/auth-store";
// import { useConsentStore } from "@/lib/stores/consentimiento-store";
import { useConsentListener } from "@/hooks/useConsentListener";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  // const hasGivenConsent = useConsentStore((state) => state.hasGivenConsent);
  const hasHydrated = useAuthStore((state) => state.hasHydrated);
  // const hasHydratedConsentimiento = useConsentStore(
  //   (state) => state.hasHydrated
  // );
  // const checkConsentimiento = useConsentStore((state) => state.checkConsent);
  const checkAuth = useAuthStore((state) => state.checkAuth);
  const [checkConsent, setCheckConsent] = useState(false);

  useConsentListener();

  useEffect(() => {
    if (!hasHydrated) {
      return;
    }

    const isAuth = checkAuth();
    // const isHaveConsentimiento = checkConsentimiento();

    if (!isAuth) {
      navigate(`${baseUrl}/sesion-expirada`, { replace: true });
      return;
    }

    // if (!isHaveConsentimiento) {
    //   navigate(`${baseUrl}/sesion-expirada`, { replace: true });
    //   return;
    // }

    if (!isAuthenticated) {
      navigate(`${baseUrl}/sesion-expirada`, { replace: true });
    }

    setCheckConsent(false);
  }, [hasHydrated, isAuthenticated, checkAuth, navigate]);

  if (!hasHydrated || checkConsent) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]" />
          <p className="mt-2 text-sm text-muted-foreground">Cargando...</p>
        </div>
      </div>
    );
  }

  return children;
}
